import styled from "styled-components";
import { designTokens, getTypography } from "styles/designTokens";

export const PanelContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 10px 10px rgba(12, 39, 58, 0.06);
  overflow: hidden;
`;

export const FilterBar = styled.div`
  display: flex;
  gap: 10px;
  padding: 24px 32px;
`;

export const ListContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 32px;
`;

export const MessageItem = styled.div<{ $isActive?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  padding: 4px 10px;
  background-color: ${({ $isActive }) =>
    $isActive ? designTokens.colors.box.primary : "transparent"};
  border-radius: 6px;
  transition: background-color 0.3s;
  cursor: pointer;

  &:hover {
    background-color: ${({ $isActive }) =>
      $isActive
        ? designTokens.colors.box.primary
        : designTokens.colors.line.point};
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

export const SpeakerLabel = styled.span`
  font-weight: 600;
`;

export const EmotionBadge = styled.span`
  padding: 2px 6px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 12px;
  color: #555;
`;

export const TextContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
`;

export const TimeRange = styled.span`
  margin: 0px;
  height: 24px;
  display: flex;
  align-items: center;
  font-size: ${getTypography("korean", "body4").fontSize};
  font-weight: ${getTypography("korean", "body4").fontWeight};
  line-height: ${getTypography("korean", "body4").lineHeight};
  letter-spacing: ${getTypography("korean", "body4").letterSpacing};
  color: ${designTokens.colors.font.tertiary};
`;

export const Text = styled.p`
  margin: 0px;
  font-size: ${getTypography("korean", "body2").fontSize};
  font-weight: ${getTypography("korean", "body2").fontWeight};
  line-height: ${getTypography("korean", "body2").lineHeight};
  letter-spacing: ${getTypography("korean", "body2").letterSpacing};
  color: ${designTokens.colors.font.tertiary};
`;

export const ActionBar = styled.div`
  display: flex;
  padding: 16px 32px;
  justify-content: space-between;
`;

export const LeftActionBar = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;

  &:hover {
    background: #f9f9f9;
  }
`;
